import React from 'react';
import Piece from './Piece';
import { positionToSquare } from '../game/logic/gameState';

const Square = ({
  row,
  col,
  piece,
  isSelected,
  isPossibleMove,
  isLastMove,
  isCheckedKing,
  onClick,
}) => {
  const isDark = (row + col) % 2 === 1;
  const squareName = positionToSquare([row, col]);
  const classes = [
    'chess-square',
    isDark ? 'chess-square--dark' : 'chess-square--light',
    isSelected ? 'chess-square--selected' : '',
    isPossibleMove ? 'chess-square--possible' : '',
    isPossibleMove && piece ? 'chess-square--capture' : '',
    isLastMove ? 'chess-square--last' : '',
    isCheckedKing ? 'chess-square--check' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      id={`square-${squareName}`}
      className={classes}
      type="button"
      role="gridcell"
      aria-label={piece ? `${squareName}, ${piece.color} ${piece.type}` : `${squareName}, empty`}
      aria-selected={isSelected}
      onClick={onClick}
    >
      {isPossibleMove && !piece && <span className="move-dot" aria-hidden="true" />}
      {isPossibleMove && piece && <span className="capture-ring" aria-hidden="true" />}
      {piece && <Piece type={piece.type} color={piece.color} isSelected={isSelected} />}
      {col === 1 && <span className="rank-label" aria-hidden="true">{9 - row}</span>}
      {row === 8 && <span className="file-label" aria-hidden="true">{'abcdefgh'[col - 1]}</span>}
    </button>
  );
};

export default Square;
